export default class QueryParamsUtils {
  /**
   * Retrieves the value of a query parameter from the current URL.
   * @param {string} name - The name of the query parameter to retrieve.
   * @returns {string|null} - The value of the query parameter or null if it does not exist.
   */
  static getUrlParameter(name) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const paramValue = url.searchParams.get(name);
    return paramValue;
  }

  /**
   * Retrieves the value of a query parameter from a given URL.
   *
   * @param {string} url - The full URL string to parse.
   * @param {string} name - The name of the query parameter to retrieve.
   * @returns {string|null} The value of the query parameter, or null if not present.
   */
  static getParameterOfUrl(url, name) {
    const parsedUrl = new URL(url);
    const paramValue = parsedUrl.searchParams.get(name);
    return paramValue;
  }

  /**
   * Retrieves both the value of a specific query parameter and the parsed URL object.
   *
   * Useful when you need to extract a parameter value and also perform other operations
   * on the URL structure (e.g., pathname, origin, etc).
   *
   * @param {string} url - The full URL string to parse.
   * @param {string} name - The name of the query parameter to retrieve.
   * @returns {{ paramValue: string|null, parsedUrl: URL }} An object containing the parameter value and the parsed URL.
   */
  static getParameterAndParsedOfUrl(url, name) {
    const parsedUrl = new URL(url);
    const paramValue = parsedUrl.searchParams.get(name);
    return {
      paramValue: paramValue,
      parsedUrl: parsedUrl
    };
  }

  /**
   * Retrieves both the value of a specific query parameter and the parsed URL object.
   *
   * Useful when you need to extract a parameter value and also perform other operations
   * on the URL structure (e.g., pathname, origin, etc).
   *
   * @param {string} name - The name of the query parameter to retrieve.
   * @returns {{ paramValue: string|null, parsedUrl: URL }} An object containing the parameter value and the parsed URL.
   */
  static getParameterAndUrl(name) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const paramValue = url.searchParams.get(name);
    return {
      paramValue: paramValue,
      parsedUrl: url
    };
  }

  /**
   * Sets or updates a query parameter in the current URL and updates the browser's history state.
   * @param {string} name - The name of the query parameter.
   * @param {string} value - The value to set for the query parameter.
   */
  static setUrlParameter(name, value) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set(name, value);
    window.history.pushState({}, "", url);
  }

  /**
   * Removes a query parameter from the URL and updates the browser's history state.
   * @param {string} name - The name of the query parameter to remove.
   */
  static removeUrlParameter(name) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.delete(name);
    window.history.pushState({}, "", url);
  }

  /**
   * Updates the browser URL to reflect the current filter.
   * @param {string} url - The new URL to push into browser history.
   */
  static updateURL(url) {
    window.history.pushState(null, "", url);
  }
  static existsUrlParameter(name) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    return url.searchParams.has(name);
  }
}